import styled from "styled-components/macro";
import { colors } from "src/theme/colors";
import { line, radii, space } from "src/theme/ui";

/**
 * The dialog's own body. Everything around it — surface, head, foot band,
 * close — comes from the `fina-dialog` chrome in GlobalStyle, which is why
 * there is so little here.
 */
export const Body = styled.div`
  padding: ${space.xl}px;
  display: flex;
  flex-direction: column;
  gap: ${space.lg}px;
`;

/** A description under the heading: 12.5px, muted, per the dialog rules. */
export const Lead = styled.p`
  margin: 0;
  font-size: 12.5px;
  line-height: 1.55;
  color: ${colors.gray[600]};
`;

export const Steps = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space.md}px;
`;

export const Step = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${space.md}px;
`;

/* A hairline pane rather than a tinted block: inside a white dialog a filled
   swatch is the same surface drawn twice. */
export const StepMark = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 34px;
  height: 34px;
  border: 1px solid ${line.hairline};
  border-radius: ${radii.control}px;
  color: ${colors.primary[500]};
`;

export const StepText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const StepTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -0.005em;
  color: ${colors.gray[900]};
`;

export const StepNote = styled.span`
  font-size: 12.5px;
  line-height: 1.45;
  color: ${colors.gray[600]};
`;
